export const API_ENDPOINT: any = [];

export const ERROR_OBJECTS: Object = {
  required: '{{field}} es requerido.',
  email: 'Introduzca un correo electrónico válido',
  minlength: 'Minimo {{value}} caracteres.',
  pattern: '{{field}} no valido.',
  passInvalid: 'Password invalido.',
  codigoIsInvalid: 'Código invalido.'
};
